// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"Wheel_canvasContainer__HASOX","wheel":"Wheel_wheel__713mG","spinning":"Wheel_spinning__dGrG5","spin":"Wheel_spin__9C_JD"};